<template>
  <!--
      作者：gmshop
      时间：2020-06-25
      描述：设置-配送设置
    -->
  <div class="common-seach-wrap">
    <el-tabs v-model="activeName">
      <el-tab-pane label="升级申请" name="first" v-if="show_Apply == true"></el-tab-pane>
      <el-tab-pane label="基础设置" name="second" v-if="show_Setting == true"></el-tab-pane>
    </el-tabs>

    <!-- 升级申请 -->
    <Apply v-if="activeName == 'first' && show_Apply == true"></Apply>
     <!-- 基础设置 -->
    <Setting v-if="activeName == 'second' && show_Setting == true"></Setting>
  </div>
</template>
<script>
import Setting from './setting/Setting';
import Apply from './apply/Apply';
export default {
  components: {
    /*基础设置*/
    Setting,
    /*升级申请*/
    Apply,
  },
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      activeName: 'first',
      /*权限检测*/
      show_Apply: false,
      show_Setting: false,
    };
  },
  created() {
    /*权限检测*/
    if(this.$filter.isAuth('/user/review/apply/Apply'))  this.show_Apply = true;
    if(this.$filter.isAuth('/user/review/setting/Setting'))  this.show_Setting = true;

    /*默认值*/
    if(this.show_Apply == true){
      this.activeName = 'first';
    }else if(this.show_Setting == true){
      this.activeName = 'second';
    }

    let active_name = localStorage.getItem('activeName')
    if(active_name){
      this.activeName = active_name
      localStorage.clear()
    }
  },
  methods: {}
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/user/review/index.vue